import React from 'react';
import ReactPlayer from 'react-player';

const VideoModal = ({videoUrl, closeModal}) => (
    <div className="videoModal-wrapper" id="videoModal" role="dialog">
        <div className="videoModal-container">
            <ReactPlayer
                url={videoUrl}
                controls={true}
                config={{
                    youtube: {
                        embedOptions: {
                            host: 'https://www.youtube-nocookie.com'
                        }
                    }
                }}
            />
            <span className="closeModal la la-close" onClick={closeModal} />
        </div>
    </div>
);

export default VideoModal;
